import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import { sleep } from '@/utils/helper';

// 查询当前组织下的数字资产
export const queryDigitalAssets: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    const isAdvanceSearch = !!payload.conditions;
    const postUrl = isAdvanceSearch ? '/v1/asset/digitalasset/advsearch' : '/v1/asset/digitalasset/search';
    commit('setDigitalAssets', { ...state.pageList, loading: true });
    const res: IPageData = await $http.post(postUrl, payload);
    commit('setDigitalAssets', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setDigitalAssets', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询数字资产详情
export const queryDigitalAssetDetail: IActionFn<IModuleState> = async ({ commit, state }, code) => {
  try {
    commit('setDigitalAssetDetail', { data: null, loading: true });
    const res = await $http.get(`/v1/asset/digitalasset/${code}/detail`);
    commit('setDigitalAssetDetail', { data: res });
    return res;
  } catch (e) {
    commit('setDigitalAssetDetail', { data: null });
  }
};

// 查询导出的文件列表
export const queryExportedFiles: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setExportFiles', { data: [], loading: true });
    const res: any = await $http.post(`/v1/asset/digitalasset/exportdetail`, payload);
    const list = (res.details || []).map((item: any) => {
      const fileDetails = (item.assetDetails || []) as any[];
      const files = fileDetails.map((file) => {
        return { fileId: file.id, fileType: file.type, fileName: file.name, viewUrl: file.viewUrl };
      });
      return { assetId: item.id, code: item.code, name: item.name, files };
    });
    commit('setExportFiles', { data: list });
  } catch (e) {
    commit('setExportFiles', { data: [] });
  }
};

// 查询导出任务状态字典
export const queryTaskStatuses: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setTaskStatuses', { ...state.taskStatuses, loading: true });
    const res = await $http.get('/common/chooseoptions/RemoteTaskStatus');
    commit('setTaskStatuses', { data: res });
  } catch (e) {
    commit('setTaskStatuses', { data: [] });
  }
};

// 创建导出任务
export const createExportTask: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setExportTaskInfo', { id: null, status: -1, progress: 0, viewUrl: '' });
    // await sleep(2);
    // const res = await $http.post('/v1/asset/digitalasset/creatcompressionfile', payload);
    const res = { id: 1, status: 1, progress: 0, viewUrl: '' };
    commit('setExportTaskInfo', res);
  } catch (e) {
    commit('setExportTaskInfo', { id: null, status: -1, progress: 0, viewUrl: '' });
  }
};

// 查询导出任务详情
export const queryExportTaskInfo: IActionFn<IModuleState> = async ({ commit, state }, taskId) => {
  try {
    await sleep(1);
    // const res = await $http.get(`/v1/asset/digitalasset/${taskId}/compressiontask`);
    const p = state.exportTaskInfo.progress + 5;
    if (p < 100) {
      const res = { ...state.exportTaskInfo, status: 2, progress: p };
      commit('setExportTaskInfo', res);
    } else {
      // const url = 'https://delight-public-dev.oss-cn-shanghai.aliyuncs.com/20230921/DPJFAA52B65F8020001FXX.gltf';
      const url = 'https://delight-public-dev.oss-cn-shanghai.aliyuncs.com/20230921/367e8147b1564badad0599277c2caf75-thumb.png';
      const res = { ...state.exportTaskInfo, status: 3, progress: 100, viewUrl: url };
      commit('setExportTaskInfo', res);
    }
  } catch (e) {
    commit('setExportTaskInfo', { id: null, status: -1, progress: 0, viewUrl: '' });
  }
};

// 查询当前用户文件任务列表
export const queryExportTaskList: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setLoading', true);
    await sleep(1);
    // const res = await $http.get('/v1/asset/digitalasset/compressiontasklist');
    const res = [{ id: 2, status: 2, progress: 50, viewUrl: '' }];
    commit('setExportStatus', { ...state.exportTaskInfo });
  } catch (e) {
    commit('setExportStatus', { ...state.exportTaskInfo });
  }
};


